const getFirstLetterFromNick = (userNick: string): string => {
  const exec = /[ㄱ-ㅎ|ㅏ-ㅣ|가-힣|a-z]+/i.exec(userNick);
  return (exec ? exec[0] : userNick).slice(0, 1);
};

export default getFirstLetterFromNick;
